import { PermissionType } from '../Api/ApiServerHooks';

// Pricing database permissions are seeded under ModuleType.DataStandards, but they are their own
// feature and must never be listed under "Správce datových standardů". Every screen that groups
// permissions by module has to exclude them and render them in their own group instead.
const pricingDatabasePermissionTypes = new Set<PermissionType>([
    PermissionType.CreatePricingDatabase,
    PermissionType.UpdatePricingDatabase,
    PermissionType.DeletePricingDatabase,
    PermissionType.CreatePricingDatabaseItem,
    PermissionType.UpdatePricingDatabaseItem,
    PermissionType.DeletePricingDatabaseItem,
    PermissionType.SharePricingDatabaseSavedPositions,
]);

export const isPricingDatabasePermission = (permissionType?: PermissionType) =>
    permissionType !== undefined && pricingDatabasePermissionTypes.has(permissionType);
